import {Component, Inject} from '@angular/core';
import * as reasons from './prewritten';
import {FormBuilder} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BoothBuildState, BoothPurchaseState, EventBooth} from "../../../entities/booths/EventBooth";
import messages from "./prewritten";
import {MatSelect, MatSelectChange} from "@angular/material/select";

@Component({
  selector: 'app-change-state',
  templateUrl: './change-state.component.html',
  styleUrls: ['./change-state.component.css']
})
export class ChangeStateComponent {

  states: string[];
  newState: string | undefined;

  comment: string = "";

  comments: string[] = Object.keys(messages);

  constructor(private _formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<ChangeStateComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ChangeStateData) {
    this.states = [];
    if(data.default !== undefined)
      this.newState = data.default;

    const stateEnum = data.type === "purchase" ? BoothPurchaseState : BoothBuildState;
    for(const key of Object.keys(stateEnum)) {
      if(!isNaN(parseInt(key)))
        continue;
      this.states.push(key);
    }
  }

  submit() {
    this.dialogRef.close({
        comment: this.comment.trim().length === 0 ? undefined : this.comment,
        state: this.newState
    })
  }

  prefill(src: MatSelect){
    this.comment = messages[src.value as string];
    src.value = undefined;
  }
}

export interface ChangeStateData {
  type: "purchase" | "approval";
  booth: EventBooth;
  default?: string;
}
